// import { Avatar, Container,ToggleButton,Typography,Box,FormControl } from "@mui/material";
import { BookmarkBorderOutlined } from "@mui/icons-material";
import BookmarkOutlinedIcon from '@mui/icons-material/BookmarkOutlined';
import { ExpandCircleDownOutlined } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Container,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  CardContent,
  IconButton,
  CircularProgress,
  Button,
  MenuItem
} from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { Card, Row } from "react-bootstrap";
import { useLocation, useNavigate, Link } from "react-router-dom";
import LineChart from "../charts/Linechart";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { endLoading, startLoading } from "../../../Redux/loadingSlice";
import Axios from "../../../config/axios";
import { UrlConstant } from "../../../commom/UrlConstant";
import Swal from "sweetalert2";
import showPremiumAlert, { getCurrentUserId, getCustomerInfoFromLocalStorage, getUserFromLocalStorage } from "../../../utils/utils";
import BuySell from "../Cards/BuySell";
import axios from "axios";
import { Grid, Select } from "@material-ui/core";
import moment from "moment";
import Successpopup from "../SharedComponent/Successpopup";
import { truncateByDomain } from "recharts/types/util/ChartUtils";
import RightSideSection from "../SharedComponent/RightSideSection";
import AiAnalysis from "../Popups/AiAnalysis";
import CandlestickChart from "../charts/CandlestickChart";
import LinChartIcon from "../../../commom/Assets/images/LineChart.png"
import CandleStickIcon from "../../../commom/Assets/images/CandleStick.png"
import { set } from "react-datepicker/dist/date_utils";
import { usePriceFormatter } from "../../../hooks";
import { formatPercentage } from "../../../utils/formatting";

const BAR_CHART_KEY = "0J7lfEpAefOuHSE6uSHdiW_5N0sThxfa";
const YAHOO_FINANCE_KEY = "W6WQ7T5PIt63txWaMW9yVsDCVVYbUD81i0eERo32";
const BASE_URL = "https://yfapi.net/ws/insights/v1/finance/insights";


function StockDetail() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const navigate = useNavigate();
  const [stockDetail, setStockDetail] = React.useState<any>({});
  const [stockFinancialDetail, setStockFinancialDetail] = React.useState<any>({});
  const [isWatchlist, setIsWatchlist] = React.useState<any>(false);
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState<any>([]);
  const [candleStickChartData, setCandleStickChartData] = useState<any>([]);
  const [tickerData, setTickerData] = useState<any>([]);
  const [tickerDataAll, setTickerAllData] = useState<any>([]);
  const [FinancialtickerDataAll, setFinancialickerAllData] = useState<any>([]);
  const [selection, setSelection] = useState<string>("1 Month");
  const [expandedCards, setExpandedCards] = useState<{ [key: number]: boolean }>({});
  const scrollRef = useRef<HTMLDivElement>(null);
  const [insights, setInsights] = useState<any>([]);
  const [showPopup, setShowPopup] = useState(false); // State for controlling popup visibility
  const [msg, setmsg] = useState(''); // State for controlling popup visibility
  const [Success, setSuccess] = useState(false); // State for controlling popup visibility
  const [heading, setheading] = useState(''); // State for controlling popup visibility
  const [isTradingAcExist, setIsTradingAcExist] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState("Create Now");
  const [isDocumentRequired, setDocumentRequired] = useState<boolean>(false);
  const [applicationId, setApplicationId] = useState("");
  const [trendValue, setTrendValue] = useState(0);
  const [trendPercentage, setTrendPercentage] = useState(0);
  const [stockDetailHistory, setStockDetailHistory] = useState<any>([]);
  const [analysisPopup, setAnalysisPopup] = useState(false);
  const [graphType, setGraphType] = useState<any>("line");
  const [stateType, setStateType] = useState<'Market Stats' | 'Ratios'>('Market Stats');

  const customerInfo = getCustomerInfoFromLocalStorage();
  const isPremium = customerInfo?.entitlements?.active?.Premium?.isActive;

  const user = getUserFromLocalStorage();

  // Initialize formatter for stock/ETF prices
  const formatter = usePriceFormatter();

  // Get currency info from Redux
  const currencyInfo = useAppSelector((state) => state.currency);



  useEffect(() => {
    if (user && user.tradingblock_application_id) {
      setIsTradingAcExist(true);
    }
  }, [user]);

  const checkAccountStatus = async () => {
    try {
      const response = await Axios.get(
        UrlConstant.TradingAccount.CheckAccountStatus
      );
      const resData = response.data;
      console.log("AC Status : ", resData);
      if (resData.status === true) {
        setApplicationStatus(resData.data.status);
        setDocumentRequired(resData.data.isDocumentUploadRequired);
        setApplicationId(resData.data.applicationId);

      }
    } catch (error: any) {
      console.error("ERRR : ", error);
    }
    finally {
    }
  };

  const handleReadMore = (index: number) => {
    setExpandedCards((prevState) => ({
      ...prevState,
      [index]: !prevState[index], // Toggle the specific card's expanded state
    }));
  };
  const handleScrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft += 200;
    }
  };
  const handleScrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft -= 200;
    }
  };

  const handleselect = (
    event: React.MouseEvent<HTMLElement>,
    newselection: string
  ) => {
    setChartData([]);
    setCandleStickChartData([]);
    setSelection(newselection);
  };

  const stock = location.state?.symbol;
  const icon = location.state?.icon;
  const title = location.state?.title
  const tradType = location.state?.tradType || "Buy";

  function calculatePriceDetails(tickerData) {
    const lastPrice = parseFloat(tickerData?.Last || "0.00");
    const previousClose = parseFloat(tickerData?.PreviousClose || "0.00");
    const diffAmount = lastPrice - previousClose;
    const percentage = (diffAmount * 100.0) / previousClose;

    return {
      lastPrice,
      previousClose,
      diffAmount,
      percentage
    };
  }

  const getStockDetail = async () => {
    dispatch(startLoading());
    setLoading(true)
    try {
      const response = await Axios.get(
        UrlConstant.Stock.GetStockDetail.replace("{0}", stock)
      );
      const resDataTicker = await Axios.get(
        UrlConstant.Stock.GetTiker.replace("{0}", stock))

      if (resDataTicker.data) {
        setTickerData(calculatePriceDetails(resDataTicker.data?.data[0]))
        setTickerAllData(resDataTicker.data?.data[0])
      }
      const resData = response.data;
      if (resData.result === true) {
        setStockDetail({
          ...resData.data,
          assetType: 'stock/etf',
        });
        setIsWatchlist(resData.data.isAddedToWatchList)
      }
    } catch (error: any) {
      console.error("ERRR : ", error);
    } finally {
      dispatch(endLoading());
      setLoading(false)
    }
  };
  const getStockFinancialDetails = async () => {
    dispatch(startLoading());
    setLoading(true)
    try {
      const response = await Axios.get(
        UrlConstant.Stock.GetStockFinancialDetail.replace("{0}", stock)
      );
      // const resDataTicker = await Axios.get(
      //   UrlConstant.Stock.GetStockFinancialDetail.replace("{0}", stock))

      // if (resDataTicker.data) {
      //   setTickerData(calculatePriceDetails(resDataTicker.data?.data[0]))
      //   setFinancialickerAllData(resDataTicker.data?.data[0])
      // }
      const resData = response.data;
      if (resData.success === true) {
        setStockFinancialDetail({
          ...resData?.data,
          assetType: 'stock/etf',
        });
        // setIsWatchlist(resData.data.isAddedToWatchList)
      }
    } catch (error: any) {
      console.error("ERRR : ", error);
    } finally {
      dispatch(endLoading());
      setLoading(false)
    }
  };
  const getStockDetailHistory = async () => {
    dispatch(startLoading());
    setLoading(true)
    try {
      const response = await Axios.get(
        UrlConstant.Stock.GetTickerHistory.replace("{0}", stock)
      );

      const resData = response.data;
      if (resData.status === true) {
        setStockDetailHistory(resData.data);
      }
    } catch (error: any) {
      console.error("ERRR : ", error);
    } finally {
      dispatch(endLoading());
      setLoading(false)
    }
  };


  const getUrlRange = (): string => {
    const now = new Date(new Date().setDate(new Date().getDate()));
    let endPoint = "";

    const formatDate = (date: Date) =>
      date.toISOString().split("T")[0]; // Format as yyyy-MM-dd

    const adjustDate = (date: Date, adjust: { days?: number; months?: number; years?: number }) => {
      if (adjust.days) date.setDate(date.getDate() + adjust.days);
      if (adjust.months) date.setMonth(date.getMonth() + adjust.months);
      if (adjust.years) date.setFullYear(date.getFullYear() + adjust.years);
      return date;
    };
    console.log(selection, adjustDate(new Date(now), { days: -1 }), "selectionselection")
    switch (selection) {
      case "1 Day":
        endPoint = `/range/15/minute/${formatDate(adjustDate(new Date(now), { days: -1 }))}/${formatDate(now)}`;
        break;
      case "5 Day":
        endPoint = `/range/1/day/${formatDate(adjustDate(new Date(now), { days: -8 }))}/${formatDate(now)}`;
        break;
      case "1 Month":
        endPoint = `/range/1/day/${formatDate(adjustDate(new Date(now), { months: -1 }))}/${formatDate(now)}`;
        break;
      case "6 Month":
        endPoint = `/range/1/week/${formatDate(adjustDate(new Date(now), { months: -6 }))}/${formatDate(now)}`;
        break;
      case "1 Year":
        endPoint = `/range/1/month/${formatDate(adjustDate(new Date(now), { years: -1 }))}/${formatDate(now)}`;
        break;
      case "5 Years":
        endPoint = `/range/1/month/${formatDate(adjustDate(new Date(now), { years: -5 }))}/${formatDate(now)}`;
        break;
      case "All":
        endPoint = `/range/1/month/1980-01-01/${formatDate(now)}`;
        break;
      default:
        endPoint = `/range/1/day/${formatDate(adjustDate(new Date(now), { days: -1 }))}/${formatDate(now)}`;
    }
    return endPoint;
  };

  const getChartData = async () => {
    dispatch(startLoading());
    console.log(getUrlRange(), "getUrlRange()")
    const fetchChartData = async (retryCount = 2) => {
      let currentDate = new Date();
      let retries = 0;

      while (retries <= retryCount) {
        // Adjust date range for the "1 Day" case
        const adjustedDate = new Date(currentDate);
        adjustedDate.setDate(currentDate.getDate() - retries);

        const startDate = adjustedDate.toISOString().split("T")[0];
        const endDate = new Date().toISOString().split("T")[0];

        const url = `https://api.polygon.io/v2/aggs/ticker/${stock}/range/15/minute/${startDate}/${endDate}?apiKey=${BAR_CHART_KEY}&sort=asc&limit=5000`;

        try {
          const response = await axios.get(url);
          console.log(response.data, "response.data");

          if (response.data.queryCount > 0) {
            const apiResponse = response.data.results;
            const chartData = apiResponse.map(item => ({
              x: new Date(item.t), // Convert Unix timestamp to Date
              y: item.c?.toFixed(2) // Extract closing price "c"
            }));

            const candleStickChartData = apiResponse.map(item => ({
              x: new Date(item.t), // Convert Unix timestamp to Date
              y: [item.o?.toFixed(2), item.h?.toFixed(2), item.l?.toFixed(2), item.c?.toFixed(2)], // Extract OHLC values
              v: item.v
            }));

            console.log(chartData, "chartData===========");
            setChartData(chartData);
            setCandleStickChartData(candleStickChartData);
            // 1 Month Trend: Last point - first point
            // Percentage calculation: ((Last point - first point) / first point) X 100
            const firstPoint = chartData[0].y;
            const lastPoint = chartData[chartData.length - 1].y;
            const percentage = ((lastPoint - firstPoint) / firstPoint) * 100;
            setTrendValue(lastPoint - firstPoint);
            setTrendPercentage(percentage);

            return; // Exit the loop and function when data is found
          } else {
            console.log(`No data for date range: ${startDate} - ${endDate}, retrying...`);
          }
        } catch (error) {
          console.error(`Error fetching chart data for range ${startDate} - ${endDate}:`, error);
        }

        retries++;
      }

      console.log("No data found after all retries");
      setChartData([]); // Set empty data if all retries fail
      setCandleStickChartData([]); // Set empty data if all retries fail
    };

    if (selection === "1 Day") {
      await fetchChartData();
    } else {

      try {
        const url = `https://api.polygon.io/v2/aggs/ticker/${stock}${getUrlRange()}?apiKey=${BAR_CHART_KEY}&sort=asc&limit=5000`;
        const response = await axios.get(url);
        console.log(response.data, "response.dataresponse.data")
        const apiResponse = response.data.results
        const chartData = apiResponse.length && apiResponse.map(item => ({
          x: new Date(item.t),  // Convert Unix timestamp to Date
          y: item.c?.toFixed(2)            // Extract closing price "c"
        }));

        const candleStickChartData = apiResponse.map(item => ({
          x: new Date(item.t), // Convert Unix timestamp to Date
          y: [item.o?.toFixed(2), item.h?.toFixed(2), item.l?.toFixed(2), item.c?.toFixed(2)], // Extract OHLC values
          v: item.v
        }));

        console.log(candleStickChartData, "candleStickChartDatacandleStickChartData")
        console.log(chartData, "chartDatachartDatachartData")
        setChartData(chartData || []);
        setCandleStickChartData(candleStickChartData || []);

        const firstPoint = chartData[0].y;
        const lastPoint = chartData[chartData.length - 1].y;
        const percentage = ((lastPoint - firstPoint) / firstPoint) * 100;
        setTrendValue((lastPoint - firstPoint));
        setTrendPercentage(percentage);
      } catch (error) {
        console.error("Error fetching chart data:", error);
      } finally {
        dispatch(endLoading());
      }
    }
  };

  const fetchFinanceInsights = async () => {
    try {
      const response = await Axios.get(
        UrlConstant.Insights.getInsightData.replace("{0}", stock)
      );

      const resData = response.data;
      if (resData.status === true) {
        setInsights(resData.data?.finance?.result?.reports)
      }
    } catch (error: any) {
      console.error("ERRR : ", error);
    } finally {
      dispatch(endLoading());
      setLoading(false)
    }
  };

  useEffect(() => {
    setExpandedCards({});
    getStockDetail();
    fetchFinanceInsights();
    // checkAccountStatus();
    getStockDetailHistory();
    getStockFinancialDetails()
  }, [stock]);

  useEffect(() => {
    getChartData();
  }, [selection]);

  const CreateWatchList = async (isAddedToWatchList) => {
    dispatch(startLoading());

    const payLoad = {
      userId: getCurrentUserId(),
      symbol: stock,
    };

    const URL = isAddedToWatchList
      ? UrlConstant.WachList.RemoveWatchList
      : UrlConstant.WachList.CreateWatchList;

    try {
      let response;

      if (isAddedToWatchList) {
        response = await Axios.delete(URL.replace("{0}", stock));
        if (response.data.result) {
          setIsWatchlist(false)
        }
      } else {
        response = await Axios.post(URL, payLoad);
        if (response.data.result) {
          setIsWatchlist(true)
        }
      }

      const resData = response.data;
      // Swal.fire(resData.msg);
      setSuccess(true)
      setShowPopup(true)
      setmsg(resData.msg)
    } catch (error) {

      console.error("ERRR : ", error);
    } finally {
      dispatch(endLoading());
    }
  };

  const closePopup = () => {
    setShowPopup(false); // Function to close the popup
  };

  const onClickAnalysis = () => {
    // if (isPremium) {
    setAnalysisPopup(true);
    // } else {
    //   showPremiumAlert(navigate)
    // }
  }

  const handleCloseAnalysis = () => {
    setAnalysisPopup(false);
  }



  return (
    <Box className="bg-color" display="flex">
      <Container
        maxWidth={false}
        className="bg-color p-3 px-5"
        style={{
          // display: "flex",
          height: "fit-content",
          width: "65%",
        }}
      >
        <Typography
          className="text-secondary"
          sx={{ marginTop: "30px", marginBottom: "30px" }}
        >
          {" "}
          <span
            onClick={() => navigation(-1)}
            style={{ color: "#4A7AF2", cursor: "pointer" }}
          >
            {title}
          </span>
          <span> / {stock}</span>
        </Typography>

        <Container
          style={{ width: "100%", left: "0", margin: "0" }}
          className="p-0"
        >
          <Box>
            <Box
              display="flex"
              alignItems="start"
              justifyContent="space-between"
            >
              <Box className="text-white">
                <Box display="flex" alignItems="center" gap="10px" mb={2}>
                  {icon ? (
                    <Avatar
                      alt={stock}
                      src={icon}
                      sx={{
                        width: 64,
                        height: 64,
                        backgroundColor: "white",
                        objectFit: "fill",
                      }}
                      className="icon"
                    />
                  ) : (
                    <Box
                      sx={{
                        width: 64,
                        minWidth: 64,
                        height: 64,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "50%",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: "bold", color: "#212529" }}
                      >
                        {stock}
                      </Typography>
                    </Box>
                  )}
                  <Box>
                    <Typography mb={1} variant="h5">
                      {stockDetail?.displayName}
                    </Typography>
                    <Typography variant="body1" className="text-secondary">
                      {stockDetail?.stockExchangeCode}:{stockDetail?.symbol}
                    </Typography>
                  </Box>
                </Box>

              </Box>

              <Box display={"flex"} flexDirection={"column"} justifyContent={"end"} >
                <Box display={"flex"} minWidth={"300px"} justifyContent={"end"}>
                  <ToggleButton
                    className="text-secondary"
                    value="watchlist"
                    sx={{
                      padding: "7px 15px !important",
                      borderRadius: "10px !important",
                      borderColor: "#FFFFFF33 !important",
                    }}
                    onClick={() => CreateWatchList(isWatchlist)}
                  >
                    {
                      isWatchlist ? <BookmarkOutlinedIcon /> : <BookmarkBorderOutlined />
                    }

                    Watchlist
                  </ToggleButton>
                  <Button
                    variant="contained"
                    color="primary"
                    className="btn-primary btn "
                    sx={{
                      padding: "7px 15px !important",
                      borderRadius: "10px !important",
                      borderColor: "#FFFFFF33 !important",
                    }}
                    onClick={() => onClickAnalysis()}
                    startIcon={
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.17666 16.2012C8.68476 16.2012 9.17956 16.0438 9.59839 15.7517C10.0169 15.4597 10.34 15.0471 10.53 14.5683C10.7199 14.0896 10.7693 13.5641 10.6727 13.0573C10.5761 12.5505 10.3373 12.0821 9.98317 11.7124C9.62886 11.3425 9.17479 11.088 8.67711 10.9847C8.17926 10.8813 7.66347 10.9346 7.19594 11.1368C6.7287 11.3388 6.33283 11.6794 6.05588 12.1121C5.77921 12.5444 5.63267 13.0504 5.6325 13.5663C5.63138 13.9096 5.69528 14.2502 5.82098 14.5687C5.9468 14.8874 6.13234 15.1785 6.36792 15.4244C6.60354 15.6704 6.88465 15.8664 7.19564 16.0002C7.50609 16.1337 7.83955 16.2023 8.17666 16.2012ZM8.17666 16.2012V15.7012L8.1786 16.2012C8.17795 16.2012 8.17731 16.2012 8.17666 16.2012ZM13.9809 20.759H9.99369C9.61302 20.759 9.25253 20.6009 8.9902 20.327C8.72858 20.0539 8.58518 19.6879 8.58518 19.3105C8.58518 18.9331 8.72858 18.5671 8.9902 18.294C9.25253 18.0202 9.61302 17.8621 9.99369 17.8621L13.9544 17.8621C13.9546 17.8621 13.9549 17.8621 13.9551 17.8621H13.9558V18.3621L13.9809 20.759ZM13.9809 20.759C13.9809 20.759 13.981 20.759 13.9811 20.759C14.1692 20.759 14.3548 20.7196 14.5267 20.6439C14.6986 20.5681 14.8528 20.4577 14.9806 20.3204C15.1084 20.1832 15.2075 20.0218 15.273 19.8462C15.3376 19.6731 15.3685 19.489 15.3644 19.3043L13.9809 20.759ZM15.7971 16.2012C15.2894 16.201 14.7949 16.0436 14.3764 15.7517C13.9578 15.4597 13.6348 15.0471 13.4448 14.5683C13.2549 14.0896 13.2055 13.5641 13.3021 13.0573C13.3986 12.5505 13.6375 12.0821 13.9916 11.7124C14.3459 11.3425 14.8 11.088 15.2977 10.9847C15.7955 10.8813 16.3113 10.9346 16.7788 11.1368C17.2461 11.3388 17.6419 11.6794 17.9189 12.1121C18.1957 12.5446 18.3423 13.051 18.3423 13.5672M15.7971 16.2012L18.3423 13.5672M15.7971 16.2012C16.1346 16.2024 16.4684 16.1339 16.7791 16.0002C17.0901 15.8664 17.3712 15.6704 17.6068 15.4244C17.8424 15.1785 18.028 14.8874 18.1538 14.5687L17.6887 14.3851M15.7971 16.2012C15.7975 16.2012 15.7978 16.2012 15.7981 16.2012V15.7012L15.7962 16.2012C15.7965 16.2012 15.7968 16.2012 15.7971 16.2012ZM15.7971 16.2012L17.6887 14.3851M18.3423 13.5672C18.3433 13.9102 18.2794 14.2505 18.1538 14.5687M18.3423 13.5672L18.1538 14.5687M17.6887 14.3851L18.1538 14.5687M17.6887 14.3851L18.1538 14.5687M21.4811 12.4871C21.4811 12.7632 21.7049 12.9871 21.9811 12.9871H22.607C22.8327 12.9922 23.0523 13.0869 23.2199 13.2586C23.3874 13.4303 23.4895 13.666 23.5 13.9191L23.5 17.2556L23.5 17.2574C23.5004 17.3813 23.4773 17.5037 23.4325 17.6173L23.8976 17.8008L23.4325 17.6173C23.3877 17.7308 23.3224 17.8325 23.2413 17.9172C23.1602 18.0019 23.0651 18.0677 22.962 18.112C22.8589 18.1564 22.7493 18.1787 22.6392 18.1782H22.6372H22.0063C21.7302 18.1782 21.5063 18.4021 21.5063 18.6782V21.1538C21.5052 21.7825 21.2653 22.381 20.8455 22.8192C20.4263 23.2568 19.8629 23.4989 19.2798 23.5H4.72021C4.13713 23.4989 3.57366 23.2568 3.15454 22.8192L2.79347 23.1651L3.15454 22.8192C2.7348 22.381 2.49491 21.7827 2.4937 21.1542V18.6782C2.4937 18.4021 2.26984 18.1782 1.9937 18.1782L1.36278 18.1782L1.36084 18.1782C1.25074 18.1787 1.14111 18.1564 1.03805 18.1121C0.934941 18.0677 0.839811 18.0019 0.758739 17.9172C0.677623 17.8326 0.612274 17.7308 0.56747 17.6173C0.522655 17.5037 0.499564 17.3813 0.500009 17.2574V17.2556L0.500013 13.9097L0.500006 13.9079C0.499564 13.784 0.522655 13.6616 0.56747 13.548C0.612274 13.4345 0.677623 13.3328 0.758739 13.2481C0.839811 13.1634 0.934941 13.0976 1.03805 13.0533C1.14111 13.0089 1.25074 12.9866 1.36084 12.9871H1.36278H1.96846C2.2446 12.9871 2.46846 12.7632 2.46846 12.4871V10.2219C2.46967 9.59336 2.70957 8.99503 3.1293 8.55685C3.54832 8.11943 4.11159 7.87733 4.69451 7.87607H11.0789C11.355 7.87607 11.5789 7.65222 11.5789 7.37607V5.03133C11.5789 4.82819 11.456 4.64523 11.2679 4.56844C10.8966 4.41682 10.5739 4.15059 10.3445 3.80078C10.115 3.45089 9.99027 3.03482 9.98896 2.6067C9.98876 2.21959 10.0898 1.841 10.2794 1.5119C10.4691 1.1828 10.7395 0.91683 11.0593 0.740206C11.3788 0.563699 11.7367 0.482337 12.0949 0.503202C12.453 0.52407 12.8008 0.646578 13.1006 0.859855C13.4006 1.07328 13.6417 1.37005 13.7956 1.72016C13.9496 2.07039 14.0095 2.45906 13.9679 2.84378C13.9264 3.22847 13.7852 3.59215 13.5619 3.89594C13.3386 4.19957 13.0422 4.43119 12.7065 4.56859C12.5186 4.64549 12.3959 4.82834 12.3959 5.03133V7.37607C12.3959 7.65222 12.6198 7.87607 12.8959 7.87607H19.255C19.8379 7.87733 20.4012 8.11943 20.8202 8.55685C21.24 8.99512 21.48 9.5936 21.4811 10.2223V12.4871Z" stroke="white" stroke-linejoin="round" />
                      </svg>
                    }
                  >
                    Ai Analysis
                  </Button>
                </Box>

              </Box>

            </Box>
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} width={"100%"} >
              <Box display="flex" gap="10px" className="text-white" alignItems="center">
                <Typography variant="h5" textAlign="end">
                  {formatter.display(tickerData?.lastPrice)}
                </Typography>
                <Typography variant="h5" style={{ color: tickerData.diffAmount == 0 ? "" : tickerData.diffAmount > 0 ? "#4edf6d" : "#ff2a2a" }}>
                  {formatter.display(tickerData.diffAmount, { showSign: true })}
                  ({formatPercentage(tickerData.percentage)})
                </Typography>
              </Box>

              <ToggleButtonGroup
                value={graphType}
                exclusive
                onChange={(e, newValue) => {
                  if (newValue) {
                    setGraphType(newValue);
                  }
                }
                }
                aria-label="Platform"
              >
                <ToggleButton value="line" style={{ width: "50px", height: "35px", padding: "10px" }} >
                  <img src={LinChartIcon} alt="Line Chart" style={{ width: "22px" }} />
                </ToggleButton>
                <ToggleButton value="candlestick" style={{ width: "50px", height: "35px", padding: "10px" }}>
                  <img src={CandleStickIcon} alt="Line Chart" style={{ width: "22px" }} />
                </ToggleButton>

              </ToggleButtonGroup>
            </Box>
          </Box>
          <Row className="dark-tbl no-border p-0 mt-4">
            <Card
              className="custom-card overflow-hidden bg-color w-100"
              style={{ height: "fit-content" }}
            >
              <Card.Body className="ps-12 p-2 h-100">
                <Box width="100%" display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
                  {/* <Box>
                    <Select
                      value={graphType}
                      onChange={(e) => setGraphType(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      className="bg-color text-white"
                      style={{ minWidth: 100, height: 40, borderRadius: 2, borderColor: "#FFFFFF33" }}
                    >
                      <MenuItem value="line">Line Chart</MenuItem>
                      <MenuItem value="candlestick">Candlestick Chart</MenuItem>
                    </Select>
                  </Box> */}
                  <Box bgcolor={trendValue > 0 ? "#4EDF6D1A" : "#FF2A2A1A"} borderRadius={50} p={"0 10px"} >
                    <Typography variant="body1" className="text-white" p={1} >
                      {/* 1 Mont Trend : <span style={{ color: "#4edf6d" }}>Up</span> */}
                      {/* trend value grater then 0 then color and bg as per that and if 0 then white and if nagetive then as per that */}
                      {selection}{' '}{trendValue > 0 ?
                        <span style={{ color: "#4edf6d" }}>{` +${formatter.display(trendValue)} (${formatter.display(trendPercentage)}%)`}</span>
                        :
                        trendValue === 0 ?
                          <span style={{ color: "#4edf6d" }}>{trendValue}</span>
                          :
                          <span style={{ color: "#ff2a2a" }}>{` ${formatter.display(trendValue)} (${formatter.display(trendPercentage)}%)`}</span>}
                    </Typography>
                  </Box>
                </Box>
                {graphType === "line" ? (
                  <LineChart
                    data={chartData}
                    timeline={selection}
                    lineColor={
                      trendValue > 0 ? "#4edf6d" : trendValue === 0 ? "#FFFFFF" : "#ff2a2a"
                    }
                  />) : (
                  <CandlestickChart
                    data={candleStickChartData}
                    timeline={selection}
                  />
                )}

                <hr style={{ borderColor: "#FFFFFF", borderWidth: "1px" }}></hr>
                <Box mb={1} display="flex" justifyContent="space-between" alignItems="center">
                  <ToggleButtonGroup
                    // className="border-white"
                    // color="primary"
                    // fullWidth
                    value={selection}
                    exclusive
                    onChange={handleselect}
                    aria-label="Platform"
                  >
                    <ToggleButton value="1 Day">1 Day</ToggleButton>
                    <ToggleButton value="5 Day">5 Day</ToggleButton>
                    <ToggleButton value="1 Month">1 Month</ToggleButton>
                    <ToggleButton value="6 Month">6 Month</ToggleButton>
                    <ToggleButton value="1 Year">1 Year</ToggleButton>
                    <ToggleButton value="5 Years">5 Years</ToggleButton>
                    <ToggleButton value="All">Max</ToggleButton>
                  </ToggleButtonGroup>
                  {/* <ToggleButtonGroup
                    // color="primary"
                    // fullWidth
                    value={graphType}
                    exclusive
                    onChange={(e, newValue) => {
                      if (newValue) {
                        setGraphType(newValue);
                      }
                    }
                    }
                    aria-label="Platform"
                  >
                    <ToggleButton value="line" style={{ width: "50px", height: "35px", padding: "10px" }} >
                      <img src={LinChartIcon} alt="Line Chart" style={{ width: "22px" }} />
                    </ToggleButton>
                    <ToggleButton value="candlestick" style={{ width: "50px", height: "35px", padding: "10px" }}>
                      <img src={CandleStickIcon} alt="Line Chart" style={{ width: "22px" }} />
                    </ToggleButton>

                  </ToggleButtonGroup> */}
                </Box>
              </Card.Body>
            </Card>
          </Row>
        </Container>

        {/* <Container style={{ width: "70%", left: "0", margin: "0" }}>
            <TotalFunds />
          </Container> */}

        {/* --------------------------------------------------- Market State --------------------------------- */}
        <Box my={5} pt={2}>
          <ToggleButtonGroup
            value={stateType}
            className="mb-3"
            exclusive
            onChange={(_, value) => value && setStateType(value)}
            sx={{
              background: '#23272F',
              borderRadius: '12px',
              p: 0.5,
              boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
              '& .MuiToggleButton-root': {
                color: 'white',
                fontWeight: 600,
                fontSize: '1rem',
                border: 0,
                borderRadius: '10px !important',
                px: 3,
                py: 1,
                transition: 'background 0.2s',
              },
              '& .Mui-selected': {
                background: '#4A7AF2',
                color: 'white',
              },
            }}
          >
            <ToggleButton value="Market Stats">Market Stats</ToggleButton>
            <ToggleButton value="Ratios">Ratios</ToggleButton>
          </ToggleButtonGroup>


          {stateType === "Market Stats" ? (
            <>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography
                  className="text-white"
                  mb={2}
                  style={{ fontSize: "1.5rem" }}
                >
                  {" "}
                  Market Stats{" "}
                </Typography>
                {/* <Link
              to="/"
              style={{
                color: "#4A7AF2",
                textDecoration: "underline !importan",
                textDecorationLine: "underline !important",
              }}
            >
              view all
            </Link> */}
              </Box>
              <Box>
                <Box display='flex' alignItems='center' gap='10px' width='100%' flexWrap='wrap'>
                  {[
                    {
                      label: "Previous Close",
                      value: formatter.display(tickerDataAll?.PreviousClose)
                    },
                    {
                      label: "Bid",
                      value: formatter.display(tickerDataAll?.Bid)
                    },
                    {
                      label: "Ask",
                      value: formatter.display(tickerDataAll?.Ask)
                    },
                    {
                      label: "52 Week High",
                      value: formatter.display(stockDetailHistory?.h)
                    },
                    {
                      label: "52 Week Low",
                      value: formatter.display(stockDetailHistory?.l)
                    },
                    // { label: "Average Volume", value: stockDetail?.averageVolumeFmt },
                    // { label: "Market Cap", value: stockDetail?.marketCapFmt },
                    // { label: "PE Ratio", value: formatPrice(stockDetail?.peRatio) },
                    // { label: "Dividend Yield", value: stockDetail?.dividendYieldFmt && parseFloat(stockDetail.dividendYieldFmt) === 0 ? "N/A" : formatPrice(stockDetail?.dividendYieldFmt) || "N/A" }

                    {
                      label: "Average Volume",
                      value: formatter.display(stockFinancialDetail?.ratios?.[0]?.average_volume, { compact: true, showSymbol: false })
                    },
                    {
                      label: "Market Cap",
                      value: formatter.display(
                        stockFinancialDetail?.ratios?.[0]?.market_cap, { compact: true }
                      )
                    },
                    {
                      label: "PE Ratio",
                      value: `${formatter.display(
                        stockFinancialDetail?.ratios?.[0]?.price_to_earnings,
                        { showSymbol: false }
                      )}x`
                    },
                    {
                      label: "Dividend Yield",
                      value:
                        stockFinancialDetail?.ratios?.[0]?.dividend_yield > 0
                          ? formatPercentage(
                            stockFinancialDetail?.ratios?.[0]?.dividend_yield
                          )
                          : "N/A"
                    }].map((item, index) => (
                      <Box key={index}>
                        <Card className="card"
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            minWidth: "190px",
                            height: '100%',
                          }}
                        >
                          <CardContent className="text-white">
                            <Typography gutterBottom>{item.label}</Typography>
                            <Typography mb="0px" mr={10}>
                              {item.value ?? "N/A"}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Box>
                    ))}
                </Box>
              </Box>
            </>
          ) : (
            <>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography
                  className="text-white"
                  mb={2}
                  style={{ fontSize: "1.5rem" }}
                >
                  {" "}
                  Ratios{" "}
                </Typography>
                {/* <Link
              to="/"
              style={{
                color: "#4A7AF2",
                textDecoration: "underline !importan",
                textDecorationLine: "underline !important",
              }}
            >
              view all
            </Link> */}
              </Box>
              <Box>
                <Box display='flex' alignItems='center' gap='10px' width='100%' flexWrap='wrap'>
                  {[
                    {
                      label: 'EPS',
                      value: formatter.display(stockFinancialDetail?.ratios?.[0]?.earnings_per_share),
                    },

                    {
                      label: 'Price To Book',
                      value: `${formatter.display(stockFinancialDetail?.ratios?.[0]?.price_to_book, { showSymbol: false })}x`,
                    },
                    {
                      label: 'Price To Sales',
                      value: `${formatter.display(stockFinancialDetail?.ratios?.[0]?.price_to_sales, { showSymbol: false })}x`,
                    },
                    {
                      label: 'Price To Cash Flow',
                      value: `${formatter.display(stockFinancialDetail?.ratios?.[0]?.price_to_cash_flow, { showSymbol: false })}x`,
                    },

                    {
                      label: 'Return On Assets',
                      value: formatPercentage(stockFinancialDetail?.ratios?.[0]?.return_on_assets),
                    },
                    {
                      label: 'Return On Equity',
                      value: formatPercentage(stockFinancialDetail?.ratios?.[0]?.return_on_equity),
                    },

                    {
                      label: 'Debt To Equity',
                      value: `${formatter.display(stockFinancialDetail?.ratios?.[0]?.debt_to_equity, { showSymbol: false })}x`,
                    },
                    {
                      label: 'Current',
                      value: `${formatter.display(stockFinancialDetail?.ratios?.[0]?.current, { showSymbol: false })}x`,
                    },
                    {
                      label: 'Quick',
                      value: `${formatter.display(stockFinancialDetail?.ratios?.[0]?.quick, { showSymbol: false })}x`,
                    },
                    {
                      label: 'Cash',
                      value: `${formatter.display(stockFinancialDetail?.ratios?.[0]?.cash, { showSymbol: false })}x`,
                    },

                    {
                      label: 'EV To Sales',
                      value: `${formatter.display(stockFinancialDetail?.ratios?.[0]?.ev_to_sales, { showSymbol: false })}x`,
                    },
                    {
                      label: 'EV To EBITDA',
                      value: `${formatter.display(stockFinancialDetail?.ratios?.[0]?.ev_to_ebitda, { showSymbol: false })}x`,
                    },
                  ].map((item, index) => (
                    <Box key={index}>
                      <Card className="card"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          minWidth: "190px",
                          height: '100%',
                        }}
                      >
                        <CardContent className="text-white">
                          <Typography gutterBottom>{item.label}</Typography>
                          <Typography mb="0px" mr={10}>
                            {/* {!['Average Volume', 'PE Ratio', 'Dividend Yield'].includes(item.label) && '$'} */}
                            {item.value ?? "N/A"}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                  ))}
                </Box>
              </Box>
            </>
          )}



        </Box>
        {/* --------------------------------------------------- Insights --------------------------------- */}
        <Box my={5} pt={2}>
          <Typography
            className="text-white"
            mb={2}
            style={{ fontSize: "1.5rem" }}
          >
            {" "}
            Insights{" "}
          </Typography>
          {insights.length > 0 ? (

            <Box display='flex' alignItems='center' justifyContent='space-between' width='100%'>
              <IconButton sx={{ pl: "0px" }} onClick={handleScrollRight}>
                <ExpandCircleDownOutlined
                  sx={{ rotate: "90deg" }}
                ></ExpandCircleDownOutlined>
              </IconButton>
              <Box
                sx={{
                  "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar in Chrome, Safari, and Edge
                }}
                style={{ scrollBehavior: "smooth", overflowX: "auto" }}
                className="scroll"
                display="flex"
                gap="20px"
                width="95%"
                overflow="hidden"
                ref={scrollRef}
              >
                {insights.map((item: any, index: number) => (
                  <Card key={index} className="card" style={{ minWidth: "530px", maxWidth: "530px", height: "fit-content" }}>
                    <CardContent className="text-white">
                      <Typography gutterBottom>{item.title}</Typography>
                      <Typography variant="body2" gutterBottom className="text-secondary">
                        {moment(item.publishedOn).format("MMMM DD, YYYY")}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          overflow: "hidden",
                          height: expandedCards[index] ? "fit-content" : "40px",
                          transition: "max-height 0.3s ease",
                        }}
                      >
                        {item.summary}
                      </Typography>
                      <span
                        onClick={() => handleReadMore(index)} // Pass the index of the card
                        style={{ color: "rgba(74, 122, 242, 1)", cursor: "pointer" }}
                      >
                        {expandedCards[index] ? "show less" : "read more"}
                      </span>
                    </CardContent>
                  </Card>
                ))}

              </Box>
              <IconButton sx={{ pl: "5px" }} onClick={handleScrollLeft}>
                <ExpandCircleDownOutlined
                  sx={{ rotate: "-90deg" }}
                ></ExpandCircleDownOutlined>
              </IconButton>
            </Box>
          ) : (
            <Card className="stock card">
              <CardContent className="text-white">
                <Box sx={{ width: "100%", color: "red", textAlign: "center" }}>
                  No Data
                </Box>
              </CardContent>
            </Card>
          )}
        </Box>

        {/* --------------------------------------------------- Dividents --------------------------------- */}
        <Box my={5} pt={2}>

          <Typography
            className="text-white"
            mb={2}
            style={{ fontSize: "1.5rem" }}
          >
            {" "}
            Dividends{" "}
          </Typography>


          <Box>
            <Card className="card" style={{ width: '260px' }}>
              <CardContent className="text-white d-flex justify-content-between">
                <Typography >{stockDetail?.lastDividendDateFmt ? moment(stockDetail?.lastDividendDateFmt).format("DD-MM-YYYY") : "N/A"}</Typography>
                <Typography mb="0px">
                  {stockDetail?.lastDividendValueFmt ? formatter.display(stockDetail?.lastDividendValueFmt) : null}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Box>
        {/* --------------------------------------------------- About --------------------------------- */}
        <Box my={5} pt={2}>

          <Typography
            className="text-white"
            mb={2}
            style={{ fontSize: "1.5rem" }}
          >
            {" "}
            About{" "}
          </Typography>


          <Box>
            <Card className="card" style={{ minWidth: '530px', maxWidth: "100%" }}>
              <CardContent className="text-white">
                <Typography gutterBottom>{stockDetail?.displayName}</Typography>
                <Typography variant="body2" gutterBottom className="text-secondary">{moment(stockDetail?.updatedAt).format("MMMM DD, YYYY")}</Typography>
                <Typography
                  variant="body2"
                // style={{ overflow: 'hidden', height: expanded ? 'fit-content' : '40px', transition: 'max-height 0.3s ease' }}
                >
                  {stockDetail?.companyDescription}
                </Typography>


              </CardContent>
            </Card>
          </Box>
        </Box>
      </Container>
      <Container style={{ width: "35%", paddingTop: "20px" }}>
        <Box width="100%">

          <Box width='440px' height='fit-content' overflow='hidden'>
            {/* {
              isTradingAcExist &&
                isDocumentRequired === false &&
                applicationStatus.toLocaleUpperCase() === "COMPLETE" ?
                <>
                  <Typography
                    component="h1"
                    fontSize={24}
                    className="text-white"
                    mb={2}
                  >
                    Buy/Sell
                  </Typography>
                  <BuySell
                    stockDetail={stockDetail}
                    tickerData={tickerData}
                    tickerDataAll={tickerDataAll}
                    icon={icon}
                    tradType={tradType}
                    assetType='stock'
                  />
                </>
                : */}
            <RightSideSection />
            {/* } */}
          </Box>
        </Box>
      </Container>
      {loading && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          bgcolor="rgba(0, 0, 0, 0.5)" // Semi-transparent black background
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{
            backdropFilter: "blur(5px)", // Blur effect
            zIndex: 9999, // Ensures the loader stays above all elements
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      )}
      {showPopup && <Successpopup Heading={heading} Success={Success} onClose={closePopup} Message={msg} />}
      {analysisPopup && <AiAnalysis stockDetail={stockDetail} symbol={stock} onClose={handleCloseAnalysis} icon={icon} tickerData={tickerData} isWatchlist={isWatchlist} CreateWatchList={CreateWatchList} />}

    </Box>
  );
}
export default StockDetail;
